import { DOG_SPEED } from './protocol.js';

export type Vec2 = { x: number; y: number };

export type MovementState = {
  x: number;
  y: number;
  tx: number;
  ty: number;
};

export type Bounds = { minX: number; minY: number; maxX: number; maxY: number };

export function clampToBounds(p: Vec2, b: Bounds): Vec2 {
  return {
    x: Math.min(b.maxX, Math.max(b.minX, p.x)),
    y: Math.min(b.maxY, Math.max(b.minY, p.y)),
  };
}

/** Symulacja ruchu do celu — ten sam kod klient (predykcja) i serwer. */
export function stepMovement(
  state: MovementState,
  dtSec: number,
  speed: number = DOG_SPEED,
  bounds?: Bounds,
): MovementState {
  const dx = state.tx - state.x;
  const dy = state.ty - state.y;
  const dist = Math.hypot(dx, dy);
  if (dist < 1) {
    let x = state.tx;
    let y = state.ty;
    if (bounds) {
      const c = clampToBounds({ x, y }, bounds);
      x = c.x;
      y = c.y;
    }
    return { x, y, tx: state.tx, ty: state.ty };
  }
  const step = Math.min(dist, speed * dtSec);
  let x = state.x + (dx / dist) * step;
  let y = state.y + (dy / dist) * step;
  if (bounds) {
    const c = clampToBounds({ x, y }, bounds);
    x = c.x;
    y = c.y;
  }
  return { x, y, tx: state.tx, ty: state.ty };
}

export const CORRECTION_THRESHOLD_PX = 32;
